<div class="dialog-wrapper">
  <div *ngIf="!isUnclosable" class="dialog-close-button-container">
    <button class="dialog-close-button" tabindex="-1" (click)="closeDialog()"></button>
  </div>
  <ng-content></ng-content>
</div>
